import Types from './../constants/bank';
import BankCustomersService from '../services/bank-customers.service';
import BankTransactionsService from '../services/bank-transactions.service';
import BankProductsService from '../services/bank-products.service';
import BankCartService from '../services/bank-cart.service';
import BankReportService from '../services/bank-report.service';
import { __ProcessFile } from './analytics';

function setBalance() {
    return async dispatch => {
        const res = await BankCustomersService.GetProfile();
        dispatch({
            type: Types.SET_BALANCE,
            payload: res.balance || 0,
        });
        return res;
    };
}

function setPendingTransactions() {
    return async dispatch => {
        const res = await BankTransactionsService.AllTransactions();
        dispatch({
            type: Types.SET_PENDING_TRANSACTIONS,
            payload: res || [],
        });
    };
}

function setPendingRootTransactions() {
    return async dispatch => {
        const res = await BankTransactionsService.AllRootTransactions();
        dispatch({
            type: Types.SET_PENDING_ROOT_TRANSACTIONS,
            payload: res || [],
        });
    };
}

function setPendingOrders() {
    return async dispatch => {
        const res = await BankTransactionsService.AllProducts();
        dispatch({
            type: Types.SET_PENDING_ORDERS,
            payload: res || [],
        });
    };
}

function setTeachersBalances() {
    return async dispatch => {
        const res = await BankCustomersService.GetInformationTeachersBalances();
        dispatch({
            type: Types.SET_TEACHERS_BALANCES,
            payload: res || [],
        });
    };
}

function setStudentsBalances() {
    return async dispatch => {
        const res = await BankCustomersService.GetInformationStudentsBalances();
        dispatch({
            type: Types.SET_STUDENTS_BALANCES,
            payload: res || [],
        });
    };
}

function setCitiesBalances() {
    return async dispatch => {
        const res = await BankCustomersService.GetInformationCitiesBalances();
        dispatch({
            type: Types.SET_CITIES_BALANCES,
            payload: res || [],
        });
    };
}

function setCountriesBalances() {
    return async dispatch => {
        const res = await BankCustomersService.GetInformationCountriesBalances();
        dispatch({
            type: Types.SET_COUNTRIES_BALANCES,
            payload: res || [],
        });
    };
}

function setProductsAllFranch() {
    return async dispatch => {
        const res = await BankProductsService.GetProductsAllFranch();

        if (res && res.response && res.response.error) {
            dispatch({
                type: Types.SET_All_PRODUCTS,
                payload: [],
            });
            return;
        }

        dispatch({
            type: Types.SET_All_PRODUCTS,
            payload: res || [],
        });
    };
}

function setAllCartItems() {
    return async dispatch => {
        const res = await BankCartService.GetCartItems();

        if (res && res.response && res.response.error) {
            dispatch({
                type: Types.SET_All_CART_ITEMS,
                payload: [],
            });
            return;
        }
        dispatch({
            type: Types.SET_All_CART_ITEMS,
            payload: res || [],
        });
    };
}

function __ClearAllBankData() {
    return dispatch => {
        dispatch({
            type: Types.CLEAR_STATE,
        });
    };
}

function setToken(customer) {
    return (dispatch, getState) => {
        dispatch({
            type: Types.REGISTRATION,
            payload: customer,
        });

        const { bank } = getState();
        const data = {
            bank: {
                ...bank,
            },
        };

        const storageNotVerified = localStorage.getItem('globalStore');
        const storage = storageNotVerified ? JSON.parse(storageNotVerified) : { bank: {} };
        localStorage.setItem('globalStore', JSON.stringify({ ...storage, ...data }));
    };
}

function getTransactionRowColor(row) {
    if (row.status === 'decline') {
        return '#ffff66cc';
    }
    if (row.status === 'wait') {
        return '#FFE28A';
    }
    if (row.statusBuy === 'success') {
        if (row.isWithdrawal) {
            return '#00ff0033';
        } else {
            return '#ff000033';
        }
    }
    if (row.statusBuy === 'decline') {
        return '#ffff66cc';
    }
    if (row.statusBuy === 'wait') {
        return '#FFE28A';
    }
    if (row.error || (row.transactionAmount < 0 && (row.status === 'wait' || row.status === 'success'))) {
        return '#ff000033';
    }
    if (row.transactionAmount >= 0 && row.status === 'success') {
        return '#00ff0033';
    }
    return 'transparent';
}

function fetchAndUpdateToken() {
    return async dispatch => {
        const res = await BankCustomersService.GetCheckExist();
        if (res && res.jwt) {
            dispatch(setToken(res));
        }
    };
}

async function confirmTransferMoney({
    rows,
    isSelected,
    toast,
    t,
    balance,
    updateBalanceFunction,
    getCustomerId = el => el.rowId,
    setSelected,
    isListRequest = false,
}) {
    const selectedRows = rows.filter(row => isSelected(row.rowId));
    const hasEmptyQuantity = selectedRows.some(row => !row.quantity);

    if (hasEmptyQuantity) {
        toast.error(t('bankStudentsPage.hasEmptyQuantity'));
        return;
    }

    let data = [];

    if (isListRequest) {
        data = selectedRows.map(el => ({
            amount: el.quantity || 1,
            studentId: el.id,
            note: el.accruedFor,
        }));
    } else {
        data = selectedRows.map(el => ({
            amount: Number(el.quantity),
            customerId: Number(getCustomerId(el)),
            note: '',
        }));
    }

    const totalAmount = data.reduce((accumulator, user) => accumulator + user.amount, 0);

    if (totalAmount <= balance) {
        if (isListRequest) {
            await BankTransactionsService.AcceptTransactions({ list: data });
        } else {
            await Promise.all(
                data.map(async item => {
                    await BankTransactionsService.TransactionById(item);
                })
            );
        }

        setSelected([]);
        updateBalanceFunction();
    } else {
        toast.error(t('sorokoinsForHomework.notEnoughMoney'));
    }
}

async function  processReportFile(data) {
    if (!data) return;
    const fileName = data.payload.fileName;
    const response = await BankReportService.DownloadDocument(fileName);
    __ProcessFile({ response, fileName });
}

export {
    setToken,
    setBalance,
    setPendingTransactions,
    setPendingRootTransactions,
    setPendingOrders,
    setProductsAllFranch,
    __ClearAllBankData,
    setAllCartItems,
    setTeachersBalances,
    setStudentsBalances,
    setCitiesBalances,
    setCountriesBalances,
    getTransactionRowColor,
    fetchAndUpdateToken,
    confirmTransferMoney,
    processReportFile,
};
